export const ORIGIN =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : 'https://nutshell.live';
export const TAPPAY_ID = '16833';
export const TAPPAY_KEY =
  'app_Lf2Fml8P5ji7Vdcae86ZKVbkXEXr7pRBHKEtTbs2r1L5s0N58kGyY4l4qNzC';
export const ENTER_ROOM_TIME_OFFSET = 16 * 60 * 1000;
export const JWT_SALT = '2tCb:7Q/';

export const MeetingReaction = {
  Clap: '👏',
  Heart: '❤️',
  Fire: '🔥',
  FaceWithHeart: '🥰',
  ThumbsUp: '👍',
  Sad: '😥',
  Woozy: '🥴',
  Beer: '🍻',
  PartyPopper: '🎉',
  Sunglasses: '😎',
  100: '💯',
  Joy: '😂',
} as const;

export const MEETING_ROOM_TOPBAR_HEIGHT = '80px';

export const EVENT_FALLBACK_COVER_PHOTO_URL =
  'https://images.pexels.com/photos/2608512/pexels-photo-2608512.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260';

export const NUTSHELL_LIVE_BLUE = '#3a92e7';

export const filterSpecialCharReg = /[^a-zA-Z0-9_]+/g;
export const noSpecialCharReg = /^[a-zA-Z0-9_]+$/;
